import { createSelector } from "@reduxjs/toolkit";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { RootState } from "@src/store/store";
import { IPOSSettings } from "./getPOSSettingsSlice";

const initialState = null;

export const { thunk: updatePOSSettings, slice: updatePOSSettingsSlice } = getThunkAndSlice<IPOSSettings, null>({
	initialState,
	path: "/Account/UpdateStageFrontPosSettingsJson",
	method: "post",
});

const _selectUpdatePOSSettingsLoading = (state: RootState) => state.POS.updatePOSSettings.loading;

export const selectUpdatePOSSettingsLoading = createSelector([_selectUpdatePOSSettingsLoading], (loading) => loading);
